// extracted by mini-css-extract-plugin
export default {"root":"kNbWGz"};